import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { SxErrorService } from 'app/services/sx-error.service';
import { FeedItem } from '@model';

@Injectable()
export class FeedService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getNewsFeed(): Observable<FeedItem[]> {
    return this.http
      .get<FeedItem[]>(`${environment.apiEndpoint}/feed`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
